<template>
  <div v-if="show" class="additional-page">
    <ResumeForm
      :formLine="formData"
      :data="data"
      ref="form"
    />
  </div>
</template>

<script>
import ResumeForm from '@/components/mobile/resumeForm.vue'
import mixin from './mixin'

export default {
  mixins: [mixin],
  components: {
    ResumeForm
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    formData () {
      return [
        {
          elType: 'text',
          name: 'professionalMemberShip',
          label: this.$t(`${this.i18nPrefix}.label.professionalMemberShip`)
        },
        {
          elType: 'text',
          name: 'awards',
          label: this.$t(`${this.i18nPrefix}.label.awards`)
        },
        {
          elType: 'text',
          name: 'hobbies',
          label: this.$t(`${this.i18nPrefix}.label.hobbies`)
        }
      ]
    }
  },
  created () {},
  mounted () {},
  methods: {
    async submit () {
      const form = await this.getForm()
      if (form) {
        const result = await form.submit()
        return result
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.additional-page {
  padding: 14px 18px;
}
</style>
